import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import * as ReactHighcharts from "react-highcharts";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";

const GrowthChurnPanel = () => {
  const metrics = useCustomQuery({
    queryKey: ["subscriptionChurnAndGrowth"],
    queryFn: () => window.CoreApi.AdminOne.SubscriptionChurnAndGrowth().then(res => res.data.data),
    initialData: [],
  });

  return <SectionPanel.Panel
    collapsible={{ start: "closed", uniqueRowId: "growth-churn-panel", persist: true }}
    header={<PanelSegment.Title title={"Growth / Churn"} />}
  >
    <ReactHighcharts
      config={{
        chart: {
          style: {
            fontFamily: "inherit"
          },
          type: "column",
          backgroundColor: "transparent"
        },
        plotOptions: {
          column: {
            borderColor: "transparent",
            dataLabels: {
              style: {
                color: "var(--text-color-light)"
              }
            }
          }
        },
        legend: {
          itemStyle: {
            color: "var(--text-color-light)",
          },
          itemHoverStyle: {
            color: "var(--text-color)",
          },
          itemHiddenStyle: {
            color: "var(--text-color-lighter)",
          },
        },
        series: [
          {
            name: "Growth",
            data: metrics.data?.map(item => item.growth) ?? [],
            color: "var(--green)"
          },
          {
            name: "Churn",
            data: metrics.data?.map(item => item.churn) ?? [],
            color: "var(--error-color)"
          }
        ],
        title: {
          text: ""
        },
        xAxis: {
          labels: {
            style: {
              color: "var(--text-color-light)"
            }
          },
          categories: metrics.data?.map(item => `${item.year} Q${item.quarter}`) ?? [],
        },
        yAxis: {
          labels: {
            style: {
              color: "var(--text-color-light)"
            }
          },
          title: {
            text: "nr of clients",
            style: {
              color: "var(--text-color-light)"
            }
          }
        },
        credits: {
          enabled: false
        }
      }}
    />
  </SectionPanel.Panel>;
};

export default GrowthChurnPanel;
